import awsconfig from "./amplify_outputs.json";

export const info_data = {
  contactMail: "no-reply@blings.io",
  support: "support@blings.io",
};
export const getENV = () => {
  // Post-refactor the bucket carries the real env name (platform-storage-bucket182631-master).
  // PRE-refactor the gen2 bucket is CDK-auto-named and truncated
  // (amplify-...-platformstoragebuckete51-...) — no env substring — so also read the
  // REST API keys, which always carry the deploy branch ("BlingsAPI-gen2-master").
  // Without this bridge the master cutover branch would resolve "dev" and silently
  // point the production frontend at dev endpoints.
  const restApiKeys = Object.keys((awsconfig as any).custom?.API ?? {});
  if (
    awsconfig.storage.bucket_name.includes("master") ||
    restApiKeys.some((k) => k.endsWith("-gen2-master"))
  )
    return "master"
  if(awsconfig.storage.bucket_name.includes("staging"))
    return "staging"
  return "dev"
};

// gen1 had getENV and getRealENV as two identical endpoint-derived lookups; dev's
// port dropped getRealENV with its callers, but master's IntegrationPage still
// imports it (IntegrationLink, LandingPageIntegration, DynamicThumbnailForm).
export const getRealENV = getENV;


export const CDN = {
  dev: "https://dh2jw0564x0cd.cloudfront.net",
  staging: "https://d25az89v0z0rdg.cloudfront.net",
  master: "https://storage.blings.io",
};
